import React, { useEffect } from "react";
import { Button, Form, Input, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { authLogo } from "util/constant";
import styled from "styled-components";
import { hideMessage, showAuthLoader, userSignIn } from "appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";
import web_login from "../assets/images/web_login.jpg";
import web_login_mobile from "../assets/images/web_login_mobile.jpg";
import smvs_text_logo from "../assets/images/smvs_text_logo.png";

const SignInWrapper = styled.div`
  .background-radial-gradient {
    height: 100vh;
    width: 100vw;
    background: url(${web_login}) no-repeat;
    background-position-x: center;
    background-size: cover;
  }
  .auth-page-logo {
    padding-bottom: 20px;
    text-align: center;
  }
  .ant-form-item-control {
    min-width: 300px;
    margin: 0 auto;
  }
  .signin-btn {
    width: 100%;
    text-align: -webkit-center;
  }
  .ant-form-item-explain-error {
    text-align: left;
    color: red;
  }
  .gx-app-login-container {
    top: 30%;
    left: 20%;
  }
  .bg-glass {
    background: hsla(0, 0%, 100%, 0.8);
  }
  .gx-loader-view {
    display: none;
  }
  .dot-pulse {
    position: relative;
    left: -9999px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #fff;
    color: #fff;
    box-shadow: 9999px 0 0 -5px #fff;
    animation: dotPulse 1.5s infinite linear;
    animation-delay: 0.25s;
  }

  .dot-pulse::before,
  .dot-pulse::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #fff;
    color: #fff;
  }

  .dot-pulse::before {
    box-shadow: 9984px 0 0 -5px #fff;
    animation: dotPulseBefore 1.5s infinite linear;
    animation-delay: 0s;
  }

  .dot-pulse::after {
    box-shadow: 10014px 0 0 -5px #fff;
    animation: dotPulseAfter 1.5s infinite linear;
    animation-delay: 0.5s;
  }

  @keyframes dotPulseBefore {
    0% {
      box-shadow: 9984px 0 0 -5px #fff;
    }
    30% {
      box-shadow: 9984px 0 0 2px #fff;
    }
    60%,
    100% {
      box-shadow: 9984px 0 0 -5px #fff;
    }
  }

  @keyframes dotPulse {
    0% {
      box-shadow: 9999px 0 0 -5px #fff;
    }
    30% {
      box-shadow: 9999px 0 0 2px #fff;
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 -5px #fff;
    }
  }

  @keyframes dotPulseAfter {
    0% {
      box-shadow: 10014px 0 0 -5px #fff;
    }
    30% {
      box-shadow: 10014px 0 0 2px #fff;
    }
    60%,
    100% {
      box-shadow: 10014px 0 0 -5px #fff;
    }
  }
  @media (max-width: 900px) {
    .gx-app-login-container {
      top: 14%;
      left: 13%;
      max-width: 467px !important;
    }
  }
  @media (max-width: 500px) {
    .background-radial-gradient {
      background: url(${web_login_mobile}) no-repeat;
      background-size: cover;
      background-position: top;
    }
    .gx-app-login-container {
      top: 32%;
      left: 0;
      max-width: 386px !important;
    }
  }
`;

const SignIn = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loader, alertMessage, showMessage, authUser } = useSelector(
    ({ auth }) => auth
  );

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 100);
    }
  });

  const handleSubmit = (values) => {
    dispatch(showAuthLoader());
    dispatch(userSignIn(values));
  };

  return (
    <SignInWrapper className="gx-app-login-wrap">
      <div className="background-radial-gradient">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content bg-glass">
            <div className="gx-app-login-content">
              <div className="auth-page-logo">
                <img
                  alt="Logo"
                  src={smvs_text_logo}
                  style={{ height: "34px", width: "231px" }}
                />
              </div>
              <Form
                className="gx-signin-form gx-form-row0"
                form={form}
                onFinish={handleSubmit}
              >
                <>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: "email",
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input type="email" placeholder="Email" />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ]}
                  >
                    <Input type="password" placeholder="Password" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      className="gx-mb-0 signin-btn"
                      htmlType="submit"
                    >
                      {loader ? (
                        <div className="dot-pulse"></div>
                      ) : (
                        <IntlMessages id="app.userAuth.signIn" />
                      )}
                    </Button>
                  </Form.Item>
                </>
              </Form>
            </div>

            {loader ? (
              <div className="gx-loader-view">
                <CircularProgress />
              </div>
            ) : null}
            {showMessage ? message.error(alertMessage.toString()) : null}
          </div>
        </div>
      </div>
    </SignInWrapper>
  );
};
export default SignIn;
